import { shopApi } from "api/shop";

export const useShopImageUpload = () => {
  const uploadImage = async (src: string | File): Promise<string> => {
    if (typeof src === "string") return src;
    const response = await shopApi.uploadImage(src);
    return response.data.url;
  };

  const uploadImages = async <T extends { src: string | File }>(
    items: T[]
  ): Promise<Array<Omit<T, "src"> & { src: string }>> => {
    return Promise.all(
      items.map(async (item) => ({
        ...item,
        src: await uploadImage(item.src),
      }))
    ) as Promise<Array<Omit<T, "src"> & { src: string }>>;
  };

  return { uploadImage, uploadImages };
};
